export enum RoleInOrganizationEnum {
  ADMIN = 1,
  LEADER = 2,
  RECRUITER = 3
}
